module.exports = __webpack_public_path__ + "img/face-border.f1989d58.png";